export default __webpack_public_path__ + "static/media/cat.0ea6fdf4.jpg";